<template>
  <div>
    <component
      :is="slice.slice_type"
      v-for="(slice, sliceIndex) in moduleContent.body"
      :key="sliceIndex"
      :slice="slice"
      :category-name="moduleContent.category_name"
      :category-uid="$route.params.slug"
    />
    <ArticlesList :articles="pageArticles" />
    <Paging
      v-if="totalPageSize > 1"
      :pages-number="totalPageSize"
      :active-page="currentPageIndex"
    />
  </div>
</template>

<script>
import { Hero } from '@@/shared-slices/'

import { ArticlesList, Paging } from './components'

export default {
  name: 'AdvicesCategoryModule',

  components: {
    Hero,
    ArticlesList,
    Paging,
  },

  props: {
    moduleContent: {
      type: Object,
      required: true,
    },
    pageArticles: {
      type: Array,
      required: true,
    },
    totalPageSize: {
      type: Number,
      required: true,
    },
    currentPageIndex: {
      type: Number,
      required: true,
    },
  },
}
</script>
